const DEFAULT_MAX_LENGTH = 25

export const truncateStationName = (
  name: string,
  maxLength = DEFAULT_MAX_LENGTH
): string => {
  if (!name) return ''
  if (name.length <= maxLength) return name
  return name.slice(0, maxLength) + '...'
}
